bam-load-more {
  &.has-margin {
    margin-bottom: 1rem;

    @include tablet() {
      margin-right: 1rem;
      margin-bottom: 0;
    }
  }
}
